import React from 'react';
import Image from '@react/shared/Image';
const PressReleaseCard = ({ title, content, image, url, date, }) => (React.createElement("div", { className: "grid-column" },
    React.createElement("a", { href: url, className: "card card-uni", "data-aos": "animated" },
        React.createElement("div", { className: "card-uni__media" },
            React.createElement("div", { className: "card-uni__media-holder" },
                React.createElement(Image, { image: image, alt: title, ratio: 1, width: 460, className: "card-uni__media-element", cdn: true }))),
        React.createElement("div", { className: "card-uni__content" },
            React.createElement("p", { className: "card-uni__date" }, new Intl.DateTimeFormat(undefined, {
                year: 'numeric',
                month: 'short',
                day: '2-digit',
            }).format(new Date(date))),
            React.createElement("h3", { className: "card-uni__title" }, title),
            React.createElement("p", { className: "card-uni__intro" }, content),
            React.createElement("div", { className: "card-uni__content-bottom" })))));
export default PressReleaseCard;
